<template>
  <div id="swayOfferPreview" class="body-2">
    <div class="sway-preview-container">
      <v-row>
        <v-col align="left" justify="left">
          <div class="text-h6 font-weight-bold">Your campaign is created 🎉</div>
        </v-col>
      </v-row>
      <div class="sway-preview-inner-container">
        <v-row>
          <v-col cols="12" class="text-left">
            <div class="font-weight-bold text-subtitle-1 mb-2">Campaign URL</div>
            <div class="d-flex" align="center">
              <v-text-field :value="shortUrl" disabled outlined />
              <v-icon style="cursor: pointer" class="mt-n7 ml-2" @click="copyUrl()">mdi-content-copy</v-icon>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="text-left">
            <div class="font-weight-bold text-subtitle-1 mb-2">Campaign QR Code</div>
            <ShortUrlQrCode :url="shortUrl" :size="150" />
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row>
      <v-col class="text-left">
        <div class="text-h6 mt-4">Next: Choose how to advertise to your customers</div>
        <v-divider />
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-6">
      <v-col cols="1" class="pa-0">
        <v-img :src="require('@/assets/images/http-link-icon.png')" width="48" :eager="true" class="avatar" />
      </v-col>
      <v-col cols="10" class="pl-8 text-left">
        <div class="mt-n1 body-1">USING YOUR CAMPAIGN URL</div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 10" :offset="$vuetify.breakpoint.smAndDown ? 0 : 2" class="text-left">
        <div class="mt-6 sway-preview-section-header">Promote On Your Social Media Pages</div>
        <div>
          Add your campaign url in your social media bio, then make a post highlighting your special deal to spread the word. <br />
          <a href="https://localfluencehelp.helpscoutdocs.com/" target="_blank">See examples</a>
        </div>
        <div class="mt-4 sway-preview-section-header">Create A Digital Coupon On Your Website</div>
        <div>
          Create a digital coupon that uses your campaign link.<br />
          <a href="https://localfluencehelp.helpscoutdocs.com/" target="_blank">See examples</a>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-10">
      <v-col cols="1" class="pa-0">
        <v-img :src="require('@/assets/images/qr-code_icon.png')" :eager="true" class="avatar" />
      </v-col>
      <v-col cols="10" class="pl-8 text-left">
        <div class="mt-n1 body-1">USING YOUR CAMPAIGN QR CODE</div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 10" :offset="$vuetify.breakpoint.smAndDown ? 0 : 2" class="text-left">
        <div class="mt-6 sway-preview-section-header">Advertise Through Print With Pre-Made Templates</div>
        <div class="font-weight-regular">
          Save time with our pre-made templates and print portal. Select from a variety of designs to create business cards, mirror clings, table tents, and
          more. Each template can be customized to fit your brand. Save and download your designs for personal printing or print and ship right from the portal.
        </div>
        <div>
          <v-row justify="center" class="mt-4">
            <v-col v-for="(printExample, index) in printExamples" :key="index" :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" align="center">
              <div class="mb-1 font-weight-bold">{{ printExample.title }}</div>
              <v-img :src="require(`@/assets/images/${printExample.image}`)" max-width="200" />
            </v-col>
          </v-row>

          <v-btn href="https://xd.adobe.com/view/a0cd794c-d27b-4b78-a403-af9b6a793296-f59e/?fullscreen" target="_blank" color="primary" class="mt-6">
            Go to templates
          </v-btn>
        </div>
        <div class="mt-10 sway-preview-section-header">Design And Print Your Own</div>
        <div>
          You have the freedom to create your own designs and use any printing service. Simply download the QR code above and add it to your design. Then print
          and display at your business to promote your campaign.
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'

import { copyToClipboard } from '@/mixins/copyToClipboard'
import ShortUrlQrCode from '@/components/Offers/OfferPanels/ShortUrlQrCode'

export default Vue.extend({
  name: 'SwayOfferPreview',

  components: {
    ShortUrlQrCode,
  },

  mixins: [copyToClipboard],

  props: {
    shortUrlId: {
      type: String,
      required: true,
    },
  },

  computed: {
    shortUrl() {
      return `${process.env.VUE_APP_SHORT_URL}${this.shortUrlId}`
    },
    printExamples() {
      return [
        {
          title: 'Business card templates',
          image: 'print-example-business-card.png',
        },
        {
          title: 'Mirror Clings/Stickers',
          image: 'print-example-stickers.png',
        },
        {
          title: 'Table Tents',
          image: 'print-example-table-tent.png',
        },
      ]
    },
  },

  methods: {
    copyUrl() {
      this.copyToClipboard(this.shortUrl)
      this.$toast.success('Copied to clipboard!')
    },
  },
})
</script>

<style scoped>
#swayOfferPreview {
  color: #707070 !important;
}

.sway-preview-container {
  padding: 20px;
  background-color: #fafafa;
}

.sway-preview-inner-container {
  padding: 15px;
  margin-top: 10px;
  background-color: #fff;
  border: 1px solid #e8e8e8;
}

.sway-preview-section-header {
  color: var(--v-primary-base);
  font-weight: 800;
}
</style>
